<template>
  <div class="return">
    <div class="top">
      <img class="line" src="../../assets/index/line.png" alt="" />
      <div class="title">{{ title1 }}</div>
      <div class="subTitle" v-html="desc1"></div>
    </div>
    <div class="img">
      <!-- <img src="../../assets/service/returnBanner.jpg" alt="" /> -->
      <img :src="`${banner}`" alt="" />
    </div>
    <div class="intro">
      <div class="top">
        <img class="line" src="../../assets/index/line.png" alt="" />
        <div class="title" v-html="title2" v-if="!this.$isMobile"></div>
        <div class="title" v-html="title2" v-else></div>
      </div>
      <div class="desc" v-html="desc2"></div>
    </div>
    <div v-html="title3" class="fangshi"></div>
    <div class="btm">
      <div
        class="lj"
        :class="active == index ? 'ljActive' : ''"
        v-for="(item, index) in list"
        :key="index"
        @mouseover="change(index)"
      >
        <div class="ljTop" v-if="active != index">
          <div>
            了解更多 <img src="../../assets/service/arrow.png" alt="" />
          </div>
        </div>
        <div class="icon" v-if="active != index">
          <img :src="item.image" alt="" />
        </div>
        <div
          class="ljTitle"
          :class="active == index ? 'ljTitleActive' : ''"
          style="white-space: pre-wrap"
          v-html="item.title"
        ></div>
        <div
          class="ljDesc"
          v-if="active == index"
          style="white-space: pre-wrap"
        >
          {{ item.desc }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { after } from "../../api/request";

export default {
  name: "Return",
  data() {
    return {
      banner: null,
      desc1: "",
      desc2: "",
      title1: "",
      title2: "",
      title3: "",
      active: 0,
      list: [
        // {
        //   id: 0,
        //   name: "微信公众平台\n" + "咨询报修",
        //   img: require("../../assets/service/return1.png"),
        //   desc: "扫描二维码或搜索阁韵铝包木窗（ID：grunen），添加阁韵铝包木窗官方微信公众服务号，点击屏幕右下角的“客户中心”菜单项，进入咨询页面输入问题描述并发送，常见问题可选择知识库查询，复杂问题或其他投诉建议可以转人工。",
        // },
        // {
        //   id: 0,
        //   name: "官方网站\n" + "咨询报修",
        //   img: require("../../assets/service/return2.png"),
        //   desc: "在浏览器中搜索阁韵木窗或阁韵窗业有限公司，或直接点击官网页面右侧咨询按钮，进入咨询页面，在输入框内键入问题描述并发送，常见问题常见问题可选择知识库查询，复杂问题或其他投诉建议可以转人工。\n",
        // },
        // {
        //   id: 0,
        //   name: "官网400\n" + "客户服务热线",
        //   img: require("../../assets/service/return3.png"),
        //   desc:
        //     "拨打阁韵窗业有限公司官方客服电话：400-8777-918，按语音提示进行转接，报修并解决问题\n" +
        //     "   \n" +
        //     "我们将竭诚为全部消费者服务！\n",
        // },
      ],
    };
  },
  mounted() {
    after().then((res) => {
      if (res.data.code == 1) {
        // console.log(res.data.data);

        var obj = res.data.data;
        this.desc1 = obj.desc1;
        this.desc2 = obj.desc2;
        this.title1 = obj.title1;
        this.title2 = obj.title2;
        this.title3 = obj.title3;
        this.list = obj.repair;
        this.banner = obj.banner;
      }
    });
  },
  methods: {
    change(index) {
      // console.log(index);
      this.active = index;
    },
    handleMouse(index) {
      this.active = index;
    },
  },
};
</script>

<style scoped lang="less">
.return {
  font-family: 微软雅黑, MicrosoftYaHei;
  .top {
    text-align: left;
    margin-left: 320px;
    background: #ffffff;
    padding: 59px 0;
    .line {
      width: 90px;
      height: 8px;
    }
    .title {
      font-size: 42px;
      font-weight: bold;
      color: #004c31;
      margin-top: 24px;
    }
    .subTitle {
      margin-top: 24px;
      width: 1282px;
      font-size: 20px;
      font-weight: 400;
      color: #6c7a77;
      line-height: 36px;
    }
  }
  .img {
    width: 100%;
    height: 631px;
    img {
      width: 100%;
      height: auto;
    }
  }
  .intro {
    display: flex;
    align-items: flex-end;
    padding-bottom: 80px;
    .desc {
      text-align: left;
      margin-left: 110px;
      width: 963px;
      font-size: 20px;
      font-weight: 400;
      color: #6c7a77;
    }
  }
  .fangshi {
    padding-top: 62px;
    padding-bottom: 42px;
    border-top: 4px solid #004c31;
    width: 1280px;
    margin: 0 auto;
    text-align: left;
    font-size: 32px;
    font-weight: 400;
    color: #004c31;
  }
  .btm {
    width: 100%;
    background: #f5f5f5;
    height: 500px;
    display: flex;
    align-items: center;
    justify-content: center;
    .lj {
      width: 303px;
      height: 500px;
      padding: 0 40px;
      border-right: 1px solid #fff;
      .ljTop {
        margin-top: 66px;
        width: 383px;
        display: flex;
        align-items: center;
        color: #214b32;
        font-size: 21px;
        img {
          margin-left: 19px;
          width: 28px;
          height: 15px;
        }
      }
      .icon {
        margin-top: 26px;
        margin-left: 140px;
        width: 140px;
        height: 137px;
        img {
          width: 140px;
          height: 137px;
        }
      }
      .ljTitle {
        margin-top: 72px;
        text-align: left;
        font-size: 32px;
        font-weight: bold;
        color: #214b32;
        position: relative;
        &::after {
          width: 43px;
          height: 4px;
          background: #004c31;
          content: "";
          position: absolute;
          top: 110px;
          left: 0;
        }
      }
    }
    .ljTitleActive {
      margin-left: 59px;
      color: #ffffff !important;
      &::after {
        width: 43px;
        height: 4px;
        background: #ffd23f !important;
        content: "";
        position: absolute;
        top: 110px;
        left: 0;
      }
    }
    .ljDesc {
      text-align: justify;
      width: 413px;
      font-size: 20px;
      font-weight: 400;
      color: #ffffff;
      margin: 100px auto 0;
    }
    .ljActive {
      width: 515px;
      transition: width 1s;
      background: #004c31;
    }
  }
}
@media screen and (max-width: 450px) {
  .return {
    overflow-x: hidden;
    font-family: 微软雅黑, MicrosoftYaHei;
    .top {
      text-align: left;
      margin-left: 320px;
      background: #ffffff;
      padding: 59px 0;
      .line {
        width: 90 * 2px;
        height: 8 * 2px;
      }
      .title {
        font-size: 42 * 2px;
        font-weight: bold;
        color: #004c31;
        margin-top: 24 * 2px;
      }
      .subTitle {
        margin-top: 24 * 2px;
        width: 1282px;
        font-size: 20 * 2px;
        font-weight: 400;
        color: #6c7a77;
        line-height: unset;
      }
    }
    .img {
      width: 100%;
      height: 631px;
      img {
        width: 100%;
        height: auto;
      }
    }
    .intro {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding-bottom: 80px;
      .desc {
        text-align: left;
        margin: 0 auto;
        width: 1282px;
        font-size: 20 * 2px;
        font-weight: 400;
        color: #6c7a77;
      }
    }
    .fangshi {
      padding-top: 62px;
      padding-bottom: 42px;
      border-top: 4px solid #004c31;
      width: 1280px;
      margin: 0 auto;
      text-align: left;
      font-size: 32 * 2px;
      font-weight: 400;
      color: #004c31;
    }
    .btm {
      margin-bottom: 40px;
      width: auto;
      background: #f5f5f5;
      height: 500 * 2px;
      display: flex;
      align-items: center;
      justify-content: center;
      .lj {
        width: 303 * 2px;
        height: 500 * 2px;
        padding: 0 40px;
        border-right: 1px solid #fff;
        .ljTop {
          margin-top: 66 * 2px;
          width: 383 * 2px;
          display: flex;
          align-items: center;
          color: #214b32;
          font-size: 21 * 2px;
          img {
            margin-left: 19 * 2px;
            width: 28 * 2px;
            height: 15 * 2px;
          }
        }
        .icon {
          margin-top: 26px;
          margin-left: 140px;
          width: 140 * 2px;
          height: 137 * 2px;
          img {
            width: 140 * 2px;
            height: 137 * 2px;
          }
        }
        .ljTitle {
          margin-top: 72px;
          text-align: left;
          font-size: 32 * 2px;
          font-weight: bold;
          color: #214b32;
          position: relative;
          &::after {
            width: 43 * 2px;
            height: 4 * 2px;
            background: #004c31;
            content: "";
            position: absolute;
            top: 180px;
            left: 0;
          }
        }
      }
      .ljTitleActive {
        overflow-y: scroll;
        margin-left: 59px;
        color: #ffffff !important;
        &::after {
          width: 43 * 2px;
          height: 4 * 2px;
          background: #ffd23f !important;
          content: "";
          position: absolute;
          top: 110 * 2px;
          left: 0;
        }
      }
      .ljDesc {
        overflow-y: scroll;
        text-align: justify;
        width: 413px;
        font-size: 20 * 2px;
        font-weight: 400;
        color: #ffffff;
        margin: 100px auto 0;
      }
      .ljActive {
        height: 500 * 2px;
        overflow-y: scroll;
        transition: unset;
        background: #004c31;
      }
    }
  }
}
</style>
